import React from "react";
import { MainAboutMe } from "./AboutWorkComponents/MainAboutMe";

export const AboutMeWork = () => {
  return (
    <view>
      <MainAboutMe />
    </view>
  );
};
